var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBostaBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1554_77636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19922 13.7998H13.5233",
    stroke: "#111619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3715 5.73288L9.33259 6.54663L5.76232 2.94463L3.939 3.43288L6.29404 7.36094L4.47103 7.84973L2.92998 6.95969L1.10697 7.44849L3.90703 10.606L13.0222 8.16343C13.3398 8.07302 13.6092 7.86133 13.7722 7.57405C13.9351 7.28676 13.9786 6.94692 13.8932 6.62787C13.8078 6.30882 13.6003 6.03615 13.3156 5.86871C13.0309 5.70127 12.6918 5.65248 12.3715 5.73288Z",
    stroke: "#111619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1554_77636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBostaBox);
export default __webpack_public_path__ + "f33401794c823db24c57a1e8d7458371.svg";
export { ForwardRef as ReactComponent };